import { Pipe, PipeTransform, inject } from '@angular/core';
import { HisUiService } from '../service/base/his-ui.service';

/**
 * looks up uitext.
 */
@Pipe( {
    name: 'hisUi',
    standalone: false
} )
export class HisUiPipe implements PipeTransform {
    private hisUiService = inject(HisUiService);


    transform( key: string, ...params: any[] ): string {
        return this.hisUiService.translate( key, ...params );
    }
}
